import React from 'react';

import { Heading } from '@fly/core';
import { Separator } from '@radix-ui/themes';
import cn from 'classnames';

interface FlyScreenCardTitleProps {
  title?: string;
  subtitle?: React.ReactNode;
  separator?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const FlyScreenCardTitle: React.FC<FlyScreenCardTitleProps> = ({
  title,
  subtitle,
  separator = true,
  children,
  className,
}) => {
  return (
    <div
      className={cn('flex flex-col pb-fly-4', className)}
      data-testid='fly-screen-card-title'
    >
      <div className='flex items-center justify-between'>
        <div className='flex flex-col gap-fly-3 pb-fly-5'>
          {title && (
            <Heading
              as='h2'
              size='2'
              highContrast
              weight='medium'
              className='capitalize'
            >
              {title}
            </Heading>
          )}
          {subtitle && (
            <Heading
              as='h3'
              size='4'
              weight='medium'
              className='capitalize'
              highContrast
            >
              {subtitle}
            </Heading>
          )}
        </div>
        {children && (
          <div className='min-w-0 flex max-w-full items-center gap-fly-4'>
            {children}
          </div>
        )}
      </div>
      {separator && <Separator orientation='horizontal' size='4' />}
    </div>
  );
};
